import { getContacts } from 'services/api/ContactServiceAPI';
import { queryKeys } from '../queryKeys';
import { useQuery } from '@tanstack/react-query';
import { GetContactsParams } from 'types/contact.type';

export const useGetContacts = (params: GetContactsParams) => {
    const { data, isLoading, refetch, ...rest } = useQuery({
        queryKey: queryKeys.contacts(params),
        queryFn: () => getContacts(params),
    });

    return {
        contactsData: data,
        isContactsLoading: isLoading,
        refetchContactsData: refetch,
        ...rest,
    };
};
